module.exports = __webpack_public_path__ + "static/media/13.4bc1e7b4.jpg";